// System-seeded stage codes (Phase 2A defaults). Users' custom stages keep their raw name.
// Kept in sync with backend/seed_phase2a.py:DEFAULT_STAGES.
export const SYSTEM_STAGE_CODES = new Set<string>([
    "new", "contacted", "meeting_scheduled", "attended", "offer_sent", "enrolled",
    "thinking", "waitlisted", "unreachable", "not_fit", "rejected",
]);

/**
 * Resolution order:
 *   1. `name_override` (any tenant rename — always wins, treated as user content across languages)
 *   2. system code → `crm.stages.{code}` i18n translation, falling back to `name`
 *   3. `name` (user-created custom stages)
 */
export function stageLabel(stage: { code: string; name: string; name_override?: string | null }, t: (k: string, opts?: any) => string): string {
    if (stage.name_override && stage.name_override.trim()) return stage.name_override;
    if (SYSTEM_STAGE_CODES.has(stage.code)) {
        return t(`crm.stages.${stage.code}`, { defaultValue: stage.name });
    }
    return stage.name;
}
